//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:['query', 'fuels']
}
